import _ from 'lodash';
import { Component, Input, Output, EventEmitter} from '@angular/core';
import { VesselModel, VesselService, OceanLineModel, AlertService} from 'app/services/index'
declare var $:any;

@Component({
  selector: 'vessel-detail',
  templateUrl: 'vessel-detail.html'
})
export class VesselDetailComponent {

    _vesselId:number;
    vessel:VesselModel = new VesselModel();
    
    @Output() onRefresh: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();

    constructor(   
        private vesselService:VesselService,
        private alertService:AlertService
    ) {
    }

    @Input() set vesselId(vesselId){
        this.vessel = new VesselModel();
        this._vesselId = vesselId;
        if(vesselId != null)this.getVessel(vesselId);
    }

    ngOnInit() {
        if(_.isEmpty(this.vesselService.oceanLineList)) {
            this.vesselService.getOceanLineList();
        }
    }

    getVessel(vesselId:number){
        this.vesselService.getVessel(vesselId).subscribe(
            res => {
                if(res.result) {
                    this.vessel = res.data;
                }
            }
        );
    }

    countrySelected(event) {
        if(event != null) {
            this.vessel.cntryCd = event.cntryCd;
            this.vessel.cntryNm = event.cntryNm;
        } else {
            this.vessel.cntryCd = null;
            this.vessel.cntryNm = null;
        }
    }

    selecedOceanLine(event:OceanLineModel) {
        if(event != null) {
            this.vessel.operCd = event.lineCd;
            this.vessel.operNm = event.lineNm;
        } else {
            this.vessel.operCd = null;
            this.vessel.operNm = null;
        }
    }

    save(){
        let that = this;
        $.sweetModal.confirm('저장하시겠습니까?', function() {
            if(that.vessel.vslId == null || that.vessel.vslId == undefined) {
                that.vesselService.postVessel(that.vessel).subscribe(
                    res =>{
                        if(res.result){
                            that.alertService.success("저장 되었습니다.");
                            that.onRefresh.emit();
                        }
                    }
                );                
            }else{
                that.vesselService.patchVessel(that.vessel).subscribe(
                    res =>{
                        if(res.result){
                            that.alertService.success("저장 되었습니다.");
                            that.onRefresh.emit();
                        }
                    }
                );    
            }

        }, function() {
        });
    }

    close(){  
        this.vessel = new VesselModel();
        this.onClose.emit();
    }
}




// WEBPACK FOOTER //
// ./src/app/containers/vessel/vessel-detail.ts